export const source = 'srp';

export enum SearchDispatcherEvent {
  AppliedFilters = 'applied_filters',
  DismissBanner = 'dismiss_banner',
  NewInventory = 'new_inventory',
  SaveSearch = 'save_search'
}
